'use strict';

var React = require('react');

var SvgImageAltMinor = function SvgImageAltMinor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6.678 6.929a.75.75 0 0 0-1.356 0l-2.25 4.75a.75.75 0 0 0 1.356.642l.389-.821h2.366l.39.821a.75.75 0 0 0 1.355-.642l-2.25-4.75Zm-.205 3.071-.473-.998-.473.998h.946Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.25 6.75a.75.75 0 0 1 .75.75v3.75h1.5a.75.75 0 0 1 0 1.5h-2.25a.75.75 0 0 1-.75-.75v-4.5a.75.75 0 0 1 .75-.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 6.75a.75.75 0 0 0 0 1.5h1v3.75a.75.75 0 0 0 1.5 0v-3.75h1a.75.75 0 0 0 0-1.5h-3.5Z"
  }));
};
SvgImageAltMinor.displayName = "ImageAltMinor";

exports.SvgImageAltMinor = SvgImageAltMinor;
